export default function linksDSR(company) {
  const urls = {
    portinari: 'https://privacy-central.securiti.ai/#/dsr/be4afc32-ef46-4076-900c-f8a35b99843d',
    ceusa: 'https://privacy-central.securiti.ai/#/dsr/5a2be127-78fc-4403-9b94-451804b6b8de',
    durafloor: 'https://privacy-central.securiti.ai/#/dsr/17ad657b-1d11-45c6-b176-599e895cde68'
  }

  return urls[company]
}